<div class="content">
  <div class="pull-left row-count">
    <span style="font-size:125%;">{{ getTotalRecords() }}</span>
  </div>
  <div *ngIf="showPaginator" class="pull-right">
    <p-paginator #paginator [rows]="table?.rows" [totalRecords]="table?.totalRecords" (onPageChange)="paginate($event)"></p-paginator>
  </div>
</div>
